import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import SendIcon from "@mui/icons-material/Send";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../../redux/slices/snackbar";
import { useDispatch } from "react-redux";
import { useDialog } from "../../../../contexts/DialogContext";
import CustomTextField from "../../../../components/CustomTextField";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import SaveIcon from "@mui/icons-material/Save";
import useUser from "../../../../hooks/useUser";

import {
  Grid,
  Divider as MuiDivider,
  Box,
  DialogActions,
  Button,
  CircularProgress,
  Typography as MuiTypography,
} from "@mui/material";
import { spacing } from "@mui/system";

import TextField from "@mui/material/TextField";
import { useForm, FormProvider } from "react-hook-form";
import useMaterial from "../../../../hooks/useMaterial";
import { identity } from "@fullcalendar/core/internal";

const Divider = styled(MuiDivider)(spacing);

const Typography = styled(MuiTypography)(spacing);

const validationSchema = Yup.object().shape({
  material: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),
  uom: Yup.string().required("Required"),
  qty: Yup.string().required("Required"),
});

function EditMaterial(props) {
  const { addMaterial, getMaterial, material, isRenewSubmitting } = useMaterial();

  const { updateUserMaterial, userMaterial, getUserMaterial } = useUser();

  console.log(userMaterial, "mataaaaa");

  const { userId, radUserId, materialId, userMaterialId, refreshPage } = props;

  const { state } = useLocation();

  console.log(state, "checkcheck");

  React.useEffect(() => {
    if (Object.keys(material).length !== 0) {
      setValue("uom", material.uom);
    }
  }, [material]);

  React.useEffect(() => {
    if (Object.keys(userMaterial).length !== 0) {
      console.log(userMaterial, "lead.status");
      const initialValues = {
        id: userMaterial.id,
        radUser: {
          label: userMaterial.radUser.userName,
          value: userMaterial.radUser.radUserId,
        },
        material: {
          value: material.userMaterial.materialId,
          label: material.userMaterial.materialName,
        },
        uom: userMaterial.uom,
        qty: userMaterial.qty,
      };
      reset(initialValues);
    }
  }, [userMaterial]);

  const currentPayload = {
    filters: [],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [],
  };

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });

  const {
    reset,
    handleSubmit,
    watch,
    formState: { errors },
    control,
    setValue,
  } = methods;

  const selectedMaterial = watch("material");

  const dispatch = useDispatch();
  const { unSetDialog, openDialog } = useDialog();
  const { t } = useTranslation();

  const { autoSearchMaterial, materialAutoSearchResults } = useMaterial();
  const [materialOptions, setmaterialOptions] = useState([]);
  const [materialPayload, setmaterialPayload] = useState(currentPayload);

  const fetchMaterial = async () => {
    await autoSearchMaterial(materialPayload);
  };
  useEffect(() => {
    fetchMaterial();
  }, [materialPayload]);

  useEffect(() => {
    console.log(materialAutoSearchResults, "materialAutoSearchResults");

    if (materialAutoSearchResults && materialAutoSearchResults.data.length !== 0) {
      const results = [...materialOptions, ...materialAutoSearchResults.data];

      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value && t.label),
      );

      filteredResults.sort((a, b) => (a.label || "").localeCompare(b.label || ""));

      setmaterialOptions(filteredResults);
    }
  }, [materialAutoSearchResults]);

  const fetchInventoryData = async () => {
    await getMaterial(selectedMaterial.value);
  };

  useEffect(() => {
    if (selectedMaterial != undefined && Object.keys(selectedMaterial).length !== 0) {
      console.log(selectedMaterial, "qwertyuqwert");
      fetchInventoryData();
    }
  }, [selectedMaterial]);

  const fetchMaterialData = async () => {
    await getUserMaterial(userMaterialId);
  };

  useEffect(() => {
    fetchMaterialData();
  }, []);

  const onSubmit = async (data) => {
    try {
      console.log(data, "==========================0000");
      console.log(userId, "dfghjmk");
      let payload = {
        radUserId: userMaterialId,
        materialId: data.material.value,
        qty: data.qty,
      };
      await updateUserMaterial(payload);
      console.log(payload, "zxcvbsdfgh");
      unSetDialog("edit_material");
      // refreshPage();
      dispatch(showSuccessSnackbar("Material update Successfully!"));
    } catch (err) {
      dispatch(showErrorSnackbar("Failed to update Material"));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <SearchableAutoComplete
                name="material"
                label={t("materials")}
                control={control}
                data={materialOptions}
                payload={materialPayload}
                setPayload={setmaterialPayload}
                loading={false}
                multiple={false}
                defaultValue={""}
                hasNextPage={false}
                fields={validationSchema.fields}
                fullWidth
                variant="outlined"
                errors={errors}
              ></SearchableAutoComplete>
            </Grid>
            <Grid item md={6}>
              <CustomTextField
                label={t("uom")}
                name="uom"
                control={control}
                disabled={true}
                fullWidth
                fields={validationSchema.fields}
                variant="outlined"
                errors={errors}
              />
            </Grid>
            <Grid item md={6}>
              <CustomTextField
                name="qty"
                label={t("quantity")}
                control={control}
                fields={validationSchema.fields}
                fullWidth
                variant="outlined"
                errors={errors}
              ></CustomTextField>
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              endIcon={isRenewSubmitting ? <CircularProgress size={24} /> : null}
              disabled={false}
            >
              Save
            </Button>

            <Button variant="text" onClick={() => unSetDialog("edit_material")} color="primary">
              Close
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default EditMaterial;
